import { useTranslation } from "react-i18next";
import { DashboardTile } from "@idwal/idwal-react-components";
import { GradeMetrics } from "../../types/Metric";
import { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { openUrl } from "../../services/WindowOpenService";
import { sendGAEvent } from "../../AnalyticsService";
import { DASHBOARD_CATEGORY, DASHBOARD_AVERAGE_GRADE_KPI_CLICK, DASHBOARD_HIGHEST_GRADE_KPI_CLICK, DASHBOARD_LOWEST_GRADE_KPI_CLICK } from "../../constants/analytics";

type Props = {
    metrics: GradeMetrics | undefined;
    loading: boolean;
};

export const GradeTiles = (props: Props) => {
    const { metrics, loading } = props;

    const { t } = useTranslation("locale");
    const navigate = useNavigate();

    const elements = useMemo(
        () => ({
            link: true,
            tooltip: false,
            colourBar: true,
            trend: false,
            label: true,
            button: false,
        }),
        []
    );

    const onAverageClick = useCallback(() => {
        sendGAEvent(DASHBOARD_CATEGORY, DASHBOARD_AVERAGE_GRADE_KPI_CLICK);
        navigate("/grade");
    }, [navigate]);

    const onBestClick = useCallback(() => {
        sendGAEvent(DASHBOARD_CATEGORY, DASHBOARD_HIGHEST_GRADE_KPI_CLICK);
		openUrl(`${process.env.REACT_APP_ID_PLATFORM_CUSTOMER_REPORT_URL_ROOT}/Inspection/${metrics?.best?.inspection_id}`);
    }, [metrics]);

    const onWorstClick = useCallback(() => {
        sendGAEvent(DASHBOARD_CATEGORY, DASHBOARD_LOWEST_GRADE_KPI_CLICK);
		openUrl(`${process.env.REACT_APP_ID_PLATFORM_CUSTOMER_REPORT_URL_ROOT}/Inspection/${metrics?.worst?.inspection_id}`);
    }, [metrics]);

    const tiles = useMemo(
        () => [
            {
                metric: t("dashboard.averageIdwalGrade"),
                value: metrics?.average,
                label: t("dashboard.acrossFleet"),
                onClick: onAverageClick,
            },
            {
                metric: t("dashboard.bestIdwalGrade"),
                value: metrics?.best?.value,
                label: `${metrics?.best?.ship_name} (${metrics?.best?.imo})`,
                onClick: onBestClick,
            },
            {
                metric: t("dashboard.worstIdwalGrade"),
                value: metrics?.worst?.value,
                label: `${metrics?.worst?.ship_name} (${metrics?.worst?.imo})`,
                onClick: onWorstClick,
            },
        ],
        [metrics, onAverageClick, onBestClick, onWorstClick]
    );

    if (!metrics && !loading) {
        return (
            <div className="flex justify-content-center">
                <p>{t("dashboard.noDashboardAvailable")}</p>
            </div>
        );
    }

    return (
        <>
            {tiles.map((tile, index) => (
                <div className="col-12 md:col-6 lg:col-4">
                    <DashboardTile
                        key={index}
                        loading={loading}
                        data={tile}
                        elements={elements}
                    />
                </div>
            ))}
        </>
    );
};
